<template>
  <OAuthAuthorize v-if="$route.name === names.MAIN" />
  <router-view v-else />
</template>

<script>

import names from "./routers/names";
import OAuthAuthorize from "@/modules/oauth/authorize/OAuthAuthorize.vue";

export default {
  name: 'OAuthBreadcrumbs',
  components: { OAuthAuthorize },
  computed: {
    names: () => names,
  },
}

</script>

<style scoped>

</style>
